import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/data/content";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      toast.error("Serve un indirizzo email valido.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Errore");
      toast.success(data.message || "Iscrizione confermata.");
      setEmail("");
    } catch (err) {
      toast.error(err.message || "Qualcosa è andato storto, riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="diario"
      data-testid="newsletter-section"
      className="relative bg-ink-surface border-t border-ink-border px-5 md:px-10 py-20 md:py-32 overflow-hidden"
    >
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-72 w-[42rem] rounded-full bg-ink-glow blur-3xl pointer-events-none" />
      <div className="relative max-w-3xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-5"
        >
          Il Diario delle Acque
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif font-light text-3xl md:text-6xl tracking-tight leading-tight"
        >
          Una lettera ogni <span className="italic text-ember">luna piena</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.16, ease: [0.16, 1, 0.3, 1] }}
          className="mt-6 text-sm md:text-base text-mist leading-relaxed max-w-xl mx-auto"
        >
          Sessioni raccontate, dichiarazioni di attrezzatura e prime notizie
          dagli albi. Niente spam: solo acque.
        </motion.p>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.24, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
        >
          <input
            data-testid="newsletter-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="la-tua-email@riva.it"
            className="flex-1 bg-ink border border-ink-border rounded-full px-6 py-4 text-sm text-bone focus:outline-none focus:border-ember transition-colors duration-300"
          />
          <button
            data-testid="newsletter-submit"
            type="submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 bg-ember text-ink font-mono text-[11px] uppercase tracking-[0.25em] px-8 py-4 rounded-full hover:bg-ember-bright transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "A bordo…" : "Iscrivimi"}
            <ArrowRight size={14} strokeWidth={1.5} />
          </button>
        </motion.form>

        <p className="mt-6 font-mono text-[9px] uppercase tracking-[0.3em] text-faint">
          frequenza: ogni luna piena — disiscrizione con un click
        </p>
      </div>
    </section>
  );
}
